import { useSearchParams } from "react-router-dom";

export default function useOpenScenarios() {
  const [searchParams, setSearchParams] = useSearchParams();

  const openScenarioIds =
    searchParams
      .get("openScenarios")
      ?.split(";")
      .filter((x) => x !== "")
      .map((x) => Number(x)) || [];

  const setOpenScenarioIds = (scenarioIds: number[]) => {
    setSearchParams((searchParams) => {
      searchParams.set("openScenarios", scenarioIds.join(";"));
      return searchParams;
    });
  };

  const openScenario = (scenarioId: number) => {
    setSearchParams((searchParams) => {
      openScenarioIds.push(scenarioId);
      searchParams.set("openScenarios", openScenarioIds.join(";"));
      return searchParams;
    });
  };

  const toggleScenario = (scenarioId: number) => {
    setSearchParams((searchParams) => {
      if (openScenarioIds.includes(scenarioId)) {
        searchParams.set(
          "openScenarios",
          openScenarioIds.filter((x) => x !== scenarioId).join(";")
        );
      } else {
        openScenarioIds.push(scenarioId);
        searchParams.set("openScenarios", openScenarioIds.join(";"));
      }
      return searchParams;
    });
  };

  return {
    openScenarioIds,
    toggleScenario,
    openScenario,
    setOpenScenarioIds,
  };
}
